import React, { FC, memo } from 'react';
import {
    Avatar,
    Content,
    ContentFooter,
    ContentHeader,
    ContentHeaderLeft,
    ContentHeaderRight,
    ContentMain,
    ContentTitle,
    ContentTitleLeft,
    ContentTitleRight,
    Wrapper,
} from './components';
import ImageViewer from 'src/components/common/ImageViewer';

interface TemplateProps {
    avatar?: string;
    header?: React.ReactNode;
    actions?: React.ReactNode;
    title?: React.ReactNode;
    extra?: React.ReactNode;
    content?: React.ReactNode;
    footer?: React.ReactNode;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { avatar, header, actions, title, extra, content, footer } = props;

    return (
        <Wrapper>
            {avatar ? (
                <Avatar>
                    <ImageViewer>
                        <img alt="" width={80} src={avatar} />
                    </ImageViewer>
                </Avatar>
            ) : null}

            <Content>
                {header || actions ? (
                    <ContentHeader>
                        <ContentHeaderLeft title={header}>{header}</ContentHeaderLeft>
                        <ContentHeaderRight>{actions}</ContentHeaderRight>
                    </ContentHeader>
                ) : null}

                {title || extra ? (
                    <ContentTitle>
                        <ContentTitleLeft title={title}>{title}</ContentTitleLeft>
                        <ContentTitleRight>{extra}</ContentTitleRight>
                    </ContentTitle>
                ) : null}

                {content ? <ContentMain title={content}>{content}</ContentMain> : null}

                {footer ? <ContentFooter>{footer}</ContentFooter> : null}
            </Content>
        </Wrapper>
    );
});

export default Template;
